export const sm = 464;
export const smMd = 580;
export const md = 744;
export const lg = 984;
export const xl = 1248;

export const phoneOnly = `(max-width: ${sm - 1}px)`;
export const notPhone = `(min-width: ${sm}px)`;
export const mobileOnly = `(max-width: ${md - 1}px)`;
export const tabletOnly = `(max-width: ${lg - 1}px)`;
export const notMobile = `(min-width: ${md}px)`;
export const desktopOnly = `(min-width: ${lg}px)`;
